import AppForm from './AppForm';
import { TSubStep } from './WizardCmp';

function WizardStep(props: {
  formType: string;
  stepNumber: number;
  subStepNumber: number;
  subSteopObj: TSubStep;
  onMoveStep: (stepMove: number) => void;
  //RECAPTCHA
  isFinalStep: boolean;
}) {
  return (
    <div className="wizard-step">
      <AppForm
        data={{
          currentSubStep: props.subSteopObj,
          formType: props.formType,
          onMoveStep: props.onMoveStep,
          //RECAPTCHA
          isFinalStep: props.isFinalStep,
        }}
      />
    </div>
  );
}

export default WizardStep;
